module.exports = __webpack_public_path__ + "img/island_banner.14610678.png";